var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-center mt-auto mb-18"
  }, [(_vm.firstLogin || _vm.emailWasJustVerified) && _vm.isCurrent ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Continuer avec l'offre gratuite",
      "icon": "arrow-right_1",
      "responsive": false,
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.continueWithFreeSubscription();
      }
    }
  }) : _vm.isCurrent ? _c('div', {
    staticClass: "relative text-sm font-normal text-gray-600 border-b border-gray-600 w-full flex items-center bottom-5"
  }, [_c('span', {
    staticClass: "absolute w-full text-center"
  }, [_c('span', {
    staticClass: "w-max-content w-max bg-indigo-200 px-2"
  }, [_vm._v("Votre offre actuelle")])])]) : _c('div', [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Contactez-nous",
      "icon": "email",
      "responsive": false,
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$store.commit('account/SET_SHOW_CONTACT_OFFER_POPUP', _vm.name);
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }